import React from 'react';

import ProgressBar from "../../components/ProgressBar/ProgressBar"

import "./LoadingOverlay.css"


function LoadingOverlay(props) {

  return (
    <div className="loading-overlay-white">

      {/* <div style={props.loadingClass} className="loading-overlay"/> */}
      <img
        src={props.backgroundImage}
        style={props.loadingClass}
        className="loading-overlay"
        alt=""
      />

      <div className="loader-container">
        <ProgressBar done={props.loadingProgress} />
      </div>

    </div>

  );
}
export default LoadingOverlay;